export enum AccordionBlock {
  Root = 'Accordion',
}

export enum AccordionModifier {
  FullHeight = 'fullHeight',
}
